const selectedOption = (variant, pattern) =>
  variant?.selectedOptions?.find((option) => pattern.test(option.name))?.value;

export const cartItemKey = (item) => item.key || `${item.id}-${item.variantId || item.size}`;

export const variantForSize = (product, size) => {
  if (!product?.variants?.length) return null;
  const matchingVariant = product.variants.find((variant) =>
    variant.title.toUpperCase().includes(String(size).toUpperCase()) && variant.available
  );
  return (matchingVariant || product.variants[0]).id;
};

const resolveVariant = (product, selection) => {
  if (!product?.variants?.length) return null;
  if (selection && typeof selection === 'object') return selection;
  const requested = String(selection || '').toUpperCase();
  return product.variants.find((variant) => variant.title.toUpperCase().includes(requested) && variant.available)
    || product.variants.find((variant) => variant.available)
    || product.variants[0];
};

const createCartItem = (product, variant, quantity) => {
  const size = selectedOption(variant, /size/i) || variant?.title || 'One size';
  const color = selectedOption(variant, /colou?r/i) || product.color;
  const image = variant?.imageUrl
    || product.media?.find((media) => media.variantIds?.includes(variant?.id))?.url
    || product.image;
  return {
    key: `${product.id}-${variant?.id || variant?.title || 'default'}`,
    id: product.id,
    size,
    qty: quantity,
    variantId: variant?.id || variantForSize(product, size),
    lookupKey: product.lookupKey,
    name: product.name,
    price: variant?.price ?? product.price,
    image,
    color,
    currency: variant?.currency || product.currency || 'USD',
  };
};

export const addCartItem = (items, product, selection, quantity = 1) => {
  const item = createCartItem(product, resolveVariant(product, selection), quantity);
  const existingIndex = items.findIndex((current) => cartItemKey(current) === item.key);
  if (existingIndex < 0) return [...items, item];
  return items.map((current, index) => index === existingIndex
    ? { ...current, qty: Math.min(current.qty + quantity, 20) }
    : current);
};

export const removeCartItem = (items, key) => items.filter((item) => cartItemKey(item) !== key);

export const setCartItemQuantity = (items, key, quantity) => (
  quantity <= 0
    ? removeCartItem(items, key)
    : items.map((item) => (cartItemKey(item) === key ? { ...item, qty: quantity } : item))
);